/* eslint-disable react/prop-types */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react/no-children-prop */

import React from 'react';
import { string, bool, oneOf } from 'prop-types';
import styled, { useTheme } from 'styled-components';
import Container from 'TMComponents/Container';
import ReactMarkdown from 'react-markdown';
import NavLink from 'TMComponents/NavLink';
import {
    H2,
    H3,
    H4,
    H5,
    H6,
    BodyReg,
    BodySm,
    BodyXs
} from 'TMComponents/Typography';
import { Link as LinkStyle } from 'TMComponents/Typography/styles';
import List from 'TMComponents/List';
import ListItem from 'TMComponents/List/ListItem';

const Link = styled(NavLink)`
    ${LinkStyle};
`;

const Wrapper = styled(Container)`
    max-width: 100%;
    ${(props) =>
        props.maxWidth &&
        `
        max-width: ${props.maxWidth}px; 
    `};
    ${(props) =>
        props.centerAlignText &&
        `
        text-align:center;
    `};
    ${({ whiteText, theme }) =>
        whiteText && `color: ${theme.colorSystem.UIText[3]} !important;`}
`;

const ContentParser = ({
    copy,
    width,
    className = '',
    listCheckMarks,
    bodyCopyVariant = 'default',
    leftAlign,
    centerAlignText,
    backgroundVariant
}) => {
    const theme = useTheme();

    return (
        <Wrapper
            leftAlign={leftAlign}
            maxWidth={width}
            centerAlignText={centerAlignText}
            whiteText={backgroundVariant === theme.colorSystem.primary[1]}>
            <ReactMarkdown
                children={copy}
                components={{
                    p: ({ children }) => {
                        switch (bodyCopyVariant) {
                            case 'small':
                                return <BodySm>{children}</BodySm>;
                            case 'extra_small':
                                return <BodyXs>{children}</BodyXs>;
                            default:
                                return <BodyReg>{children}</BodyReg>;
                        }
                    },
                    a: ({ href, children }) => (
                        <Link href={href}>{children}</Link>
                    ),
                    ul: ({ children }) => (
                        <List
                            listCheckMarks={listCheckMarks}
                            centerAlignText={centerAlignText}>
                            {children}
                        </List>
                    ),
                    li: ({ key, children }) => (
                        <ListItem
                            key={key}
                            listCheckMarks={listCheckMarks}
                            listTickVariant="green">
                            {children}
                        </ListItem>
                    ),
                    h1: ({ children }) => <H2>{children}</H2>,
                    h2: ({ children }) => <H2>{children}</H2>,
                    h3: ({ children }) => <H3>{children}</H3>,
                    h4: ({ children }) => <H4>{children}</H4>,
                    h5: ({ children }) => <H5>{children}</H5>,
                    h6: ({ children }) => <H6>{children}</H6>
                }}
                className={className}
            />
        </Wrapper>
    );
};

ContentParser.propTypes = {
    copy: string.isRequired,
    className: string,
    listCheckMarks: bool,
    bodyCopyVariant: oneOf(['default', 'small', 'extra_small']),
    centerAlignText: bool
};

export default ContentParser;
